;(function () {
  angular
    .module('contrast.unsaved-changes')
    .directive('confirmOnExit', function ($location, $translate, dialogs) {
      'ngInject'

      return {
        scope: {
          confirmOnExit: '&'
        },
        require: '^form',
        link: function (scope, elem, attrs, formCtrl) {
          scope.$on('$locationChangeStart', function (event) {
            if (formCtrl.$dirty && formCtrl.$valid) {
              event.preventDefault()
              var url = $location.url()
              dialogs
                .confirm(
                  $translate.instant('title_settings_unsavedChanges'),
                  $translate.instant(
                    'detail_settings_unsavedChangesConfirmation'
                  ),
                  {
                    size: 'sm',
                    yes: $translate.instant('action_save'),
                    no: $translate.instant('action_doNotSave')
                  }
                )
                .result.then(
                  function () {
                    var result = scope.confirmOnExit()
                    result.then(function () {
                      $location.path(url)
                    })
                  },
                  function () {
                    formCtrl.$dirty = false
                    $location.path(url)
                  }
                )
            }
          })
        }
      }
    })
})()
